<template>
    <div>
        <navbar></navbar>
        <!--END Navbar-->

        <template v-if="user !== null && coupons.length > 0">
            <h1>{{user.name}}</h1>
            <b-card>
                <b-table :fields="table.fields" :items="coupons"></b-table>
            </b-card>
        </template>

    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'

    export default {
        name: "Details",
        components: {Navbar},
        data() {
            return {
                coupons: [],
                user: null,
                table: {
                    fields: [
                        {
                            key: 'coupon_code',
                            label: 'code'
                        },
                        {
                            key: 'coupon_amount',
                            label: 'percent %'
                        },
                        {
                            key: 'coupon_price_limit',
                            label: 'price limit €'
                        },
                        {
                            key: 'coupon_status',
                            label: 'status'
                        },
                        {
                            key: 'coupon_expired_at',
                            label: 'expiry date'
                        },
                    ]
                },
            }
        },
        methods: {
            getDatils() {
                if (this.$route.params.userid && this.$route.params.userid > 0) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'coupon/show/' + this.$route.params.userid)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.coupons = response.data.data.coupons;
                                this.user = response.data.data.user;
                            } else {
                                Notification.error(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            }
        },
        created() {
            this.getDatils();
        }
    }
</script>

<style scoped>

</style>